import axios from "axios";

// In dev, CRA's "proxy" field in package.json forwards /api/* to http://localhost:5000.
// In production, set REACT_APP_API_BASE to your deployed API URL at build time.
const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE || "/api",
});

// Attach the JWT (if present) to every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("vrm_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// On 401, clear the session and bounce to login —
// but skip auth endpoints (wrong OTP / wrong password should just show an error, not log the user out)
api.interceptors.response.use(
  (res) => res,
  (err) => {
    const url = err.config?.url || "";
    const isAuthEndpoint = url.includes("/auth/");
    if (err.response?.status === 401 && !isAuthEndpoint) {
      localStorage.removeItem("vrm_token");
      localStorage.removeItem("vrm_user");
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export default api;
